export const RESET_FAV_PAGE = 'resetFavPage';
export const FETCH_FAV_PAGE = 'fetchFavPage';
export const ADD_BANNER_PAGE_TO_CLOSED_BANNERS = 'ADD_BANNER_PAGE_TO_CLOSED_BANNERS';
export const SET_LINES = 'SET_LINES';
